import { render, staticRenderFns } from "./showInfo.vue?vue&type=template&id=60cfaf8b&scoped=true&"
import script from "./showInfo.vue?vue&type=script&lang=js&"
export * from "./showInfo.vue?vue&type=script&lang=js&"
import style0 from "./showInfo.vue?vue&type=style&index=0&id=60cfaf8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cfaf8b",
  null
  
)

export default component.exports